import React from "react";
import { useListContext } from "react-admin";
import { RaGrid } from "ra-compact-ui";
import DatagridReferenceTextField from "../../../components/DatagridReferenceTextField";
import ShowTitle from "../../../components/ShowTitle";
import { DatagridTextField } from "../../../components";

const BranchOfficesIterator = () => {
  const { ids, data, basePath } = useListContext();

  return (
    <>
      <RaGrid item xs={12}>
        <ShowTitle title="Sucursales" />
      </RaGrid>
      {ids.map((id, index) => (
        <RaGrid key={index} container item xs={12}>
          <RaGrid item xs={4}>
            <DatagridTextField
              resource="legal-people"
              emptyText="–"
              source="branchOfficeName"
              id={id}
              data={data}
            />
          </RaGrid>
          <RaGrid item xs={4}>
            <DatagridTextField
              resource="legal-people"
              emptyText="–"
              source="branchManagerName"
              id={id}
              data={data}
            />
          </RaGrid>

          <RaGrid item xs={4}>
            <DatagridTextField
              resource="legal-people"
              emptyText="–"
              source="phoneNumber"
              id={id}
              data={data}
            />
          </RaGrid>
          <RaGrid item xs={4}>
            <DatagridTextField
              resource="legal-people"
              emptyText="–"
              source="otherPhone"
              id={id}
              data={data}
            />
          </RaGrid>
          <RaGrid item xs={4}>
            <DatagridTextField
              resource="legal-people"
              emptyText="–"
              source="email"
              id={id}
              data={data}
            />
          </RaGrid>
          <RaGrid item xs={4}>
            <DatagridTextField
              resource="legal-people"
              emptyText="–"
              source="address"
              id={id}
              data={data}
            />
          </RaGrid>
          <RaGrid item xs={4}>
            <DatagridReferenceTextField
              resource="legal-people"
              source="countryId"
              reference="countries"
              id={id}
              data={data}
              basePath={basePath}
            />
          </RaGrid>
          <RaGrid item xs={4}>
            <DatagridReferenceTextField
              resource="legal-people"
              source="provinceId"
              reference="provinces"
              id={id}
              data={data}
              basePath={basePath}
            />
          </RaGrid>
          <RaGrid item xs={4}>
            <DatagridReferenceTextField
              resource="legal-people"
              source="cityId"
              reference="cities"
              id={id}
              data={data}
              basePath={basePath}
            />
          </RaGrid>
        </RaGrid>
      ))}
    </>
  );
};

BranchOfficesIterator.defaultProps = {
  addLabel: true,
  data: {},
  ids: [],
};

export default BranchOfficesIterator;
